var rtl_rtlignore_default = {
  "rtl": "DqUP-",
  "ltr": "EcuLY"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
